import { IAlert } from "../interfaces";

export const Toast = ({ alert, style }: { alert: IAlert, style: any }) => {
    return (
        <div style={style} className={`toast toast-${alert.type} left-auto right-48`} role="alert">
            {alert.message}
        </div>
    );
};
